import { render, staticRenderFns } from "./DrawerInfo.vue?vue&type=template&id=65c32220&"
import script from "./DrawerInfo.vue?vue&type=script&lang=js&"
export * from "./DrawerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports